import { createAccountDeletionFactory } from '../../factories/accountDeletion'
import type { DatabaseWithTransaction } from '../../types'

type DeleteAccountsParameters = {
  database: DatabaseWithTransaction
  accountIds: number[]
}

/** accountIds に該当する account 削除 / 同時に関連データ削除
 * - account に紐づく action account relation 削除
 * - account に紐づく account csv 削除
 * - account csv に紐づく action csv relation 削除
 * - account に紐づく account exchange api 削除
 * - account に紐づく action のうち、他の account に紐づかない action に対して以下削除
 *   - accounting transaction transfer
 *   - accounting transaction
 *   - action transfer
 *   - action
 *   - action source ... action source に紐づく全ての action が削除対象に含まれる source のみ
 * - account に紐づく account evm tx index relation 削除
 * - account evm tx index relation と同一 tx hash に紐づく account evm tx index relation の analyzed = false に変更
 * - account に紐づく account polkadot extrinsic relation 削除
 * - account に紐づく solana token account 削除
 * - account に紐づく account solana signature 削除
 * - account solana signature と同一 signature に紐づく account solana signature の analyzed = false に変更
 * - 削除対象となる action が存在した場合、 portfolio の　isTxGenerated を false に変更
 * - 削除対象となる action が存在した場合、全ての action の generatedTx を false に変更
 */
export const deleteAccounts = async ({
  database,
  accountIds,
}: DeleteAccountsParameters) => {
  const factory = createAccountDeletionFactory()
  await factory.deleteByIds(database, accountIds)
}
